import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheDataEngineer = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🛠️ Recruter un Data Engineer
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Data Engineer est responsable de la conception, du développement et de la maintenance des infrastructures de données. Il prépare les bases techniques nécessaires aux Data Scientists, Analystes et applications métier en assurant la qualité, la disponibilité et la scalabilité des données. Son rôle est essentiel dans la chaîne de valorisation de la donnée.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Construire et maintenir des pipelines de données robustes (ETL/ELT)</li>
          <li>Concevoir des architectures data dans le cloud ou sur site</li>
          <li>Intégrer des sources de données hétérogènes (API, bases relationnelles, fichiers, etc.)</li>
          <li>Gérer les bases de données (SQL, NoSQL) et assurer leur performance</li>
          <li>Garantir la qualité, la sécurité et la gouvernance des données</li>
          <li>Collaborer avec les Data Scientists et équipes BI/produit</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Langages : Python, SQL, Scala</li>
          <li>Outils ETL : Airflow, dbt, Talend</li>
          <li>Bases de données : PostgreSQL, MongoDB, BigQuery, Redshift</li>
          <li>Stockage & cloud : AWS (S3, Glue), Azure, GCP</li>
          <li>DevOps/DataOps : Docker, Git, CI/CD, monitoring</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : premières expériences en traitement de données et automatisation</li>
          <li>Confirmé : pipelines data complexes, gestion de flux temps réel</li>
          <li>Senior / Architecte : design global d’architectures data, supervision de projets de grande envergure</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 350–450 € / jour</li>
          <li>Confirmé : 500–650 € / jour</li>
          <li>Senior / Architecte : 700–900 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheDataEngineer;
